import {
  FormControlLabel,
  Switch as MuiSwitch,
  type SwitchProps as MuiSwitchProps,
} from "@mui/material";

export interface SwitchProps extends MuiSwitchProps {
  label: string;
}

/**
 * Still on MUI rather than `RavenSwitch`: the package component's props are
 * `{ label, checked, onChange, disabled }` only — no `size`, `sx` or
 * `className` — so ESS's dense switch (`size="small"`, 40×24 instead of
 * 58×38) and its `body2` label cannot be expressed through it. Swap this
 * over once the package forwards those.
 */
export default function Switch({ label, ...rest }: SwitchProps) {
  return (
    <FormControlLabel
      control={<MuiSwitch size="small" {...rest} />}
      label={label}
      slotProps={{ typography: { variant: "body2" } }}
    />
  );
}
